import axios from 'axios';
import { setupCache } from 'axios-cache-adapter';
import { setHumpsInterceptors } from '../interceptors/interceptors';

// eslint-disable-next-line import/prefer-default-export
export const getAxiosWithCache = (milliseconds = 60 * 60 * 1000) => {
  const cache = setupCache({
    maxAge: milliseconds, // 1 hour by default
  });

  const axiosWithCache = axios.create({
    adapter: cache.adapter,
  });

  setHumpsInterceptors(axiosWithCache);

  return axiosWithCache;
};
